import React, { useState } from 'react';
import Chart from 'react-apexcharts';

const DashChart = () => {
    const [options, setOptions] = useState({
        chart: {
            id: 'mixed-chart',
            type: 'line', 
            stacked: false,
        },
        stroke: {
            width: [0, 4], 
        },
        xaxis: {
            categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
        },
    });

    const [series, setSeries] = useState([
        {
            name: 'Website Views',
            type: 'line', // Line series
            data: [44, 55, 41, 67, 22, 43],
        },
        {
            name: 'Blog Posts',
            type: 'column', // Column series
            data: [13, 23, 20, 8, 13, 27],
        },
    ]);

    return (
        <div>
            <Chart options={options} series={series} type="line" width="100%" height="auto" />
        </div>
    );
}


export default DashChart